import Masonry from 'masonry-layout';

export default class GarbageBagSelector {
    constructor() {
        this.state = {
            filters: [],
            currentFilter: null,
            currentTab: null,
        };

        this.grid = document.querySelector('.js-box-grid');
        this.msnry = new Masonry(this.grid, {
            itemSelector: '.masonry-brick',
            columnWidth: '.grid-sizer',
            gutter: 20,
            isFitWidth: true,
            isResizable: true,
            transitionDuration: '0.2s',
            percentPosition: true,
            horizontalOrder: true,
            isAnimated: true,
            animationOptions: {
                duration: 250,
                easing: 'linear',
                queue: false,
            },
        });

        this.initMasonry();
        this.initListeners();

        $('.js-navbar .list__item:first-child .js-toggle-tab').click();
    }

    initMasonry() {
        this.msnry.on('layoutComplete', () => {
            this.grid.classList.add('load');
        });

        this.msnry.layout();
    }

    initListeners() {
        $('.js-toggle-tab').on('click', (e) => {
            $('.js-toggle-tab').removeClass('active');

            $(e.currentTarget).addClass('active');

            this.state.currentTab = $(e.currentTarget).data('tab');

            this.toggleOptions();
        });

        $('.js-toggle-option').on('click', (e) => {
            const filterValue = $(e.currentTarget).data('term');

            this.addToFilters(filterValue);
        });

        $('.js-reset-options').on('click', (e) => {
            $('.js-toggle-option').prop('checked', false);
            $('.js-toggle-option').prop('disabled', false);
            $('.js-product').fadeIn();

            this.state.currentFilter = null;
            this.state.filters = [];
            this.msnry.layout();
        });
    }

    addToFilters(filterValue) {
        this.state.currentFilter = filterValue;

        if (!this.state.filters.includes(filterValue)) {
            this.state.filters.push(filterValue);
        }

        this.render();
    }

    toggleOptions() {
        $('.options__list').hide();
        $(`.list--${this.state.currentTab}`).show();
    }

    updateTiles() {
        $('.js-product').each((index, element) => {
            if (!$(element).hasClass(this.state.currentFilter)) {
                $(element).fadeOut(() => {
                    this.msnry.layout();
                    this.updateOptions();
                });
            }
        });
    }

    updateOptions() {
        $('.js-toggle-option').each((index, element) => {
            const term = $(element).data('term');

            if ($(`.${term}:visible`).length == 0) {
                $(element).prop('disabled', true);
            }
        });
    }

    render() {
        this.updateTiles();
    }
}
